import type { TOC } from '@ember/component/template-only';

interface HotelMarketInsightTablesCellsTdBucketColorSignature {
  Args: {
    value: string;
  };
}

const HotelMarketInsightTablesCellsTdBucketColor = <template>
  <div class="td-bucket-color demand-main-bg-color--level-{{@value}}"></div>
</template> satisfies TOC<HotelMarketInsightTablesCellsTdBucketColorSignature>;

export default HotelMarketInsightTablesCellsTdBucketColor;
